









export default {
  name: "voertuigbronnen-icon",
  props: {
    title: {
      type: String,
      default: "Voertuigbronnen icon"
    },
    decorative: {
      type: Boolean,
      default: false
    }
  }
}
